'use strict';

export default {
  //url编码
  encode: function (params) {
    return window.btoa(window.encodeURIComponent(JSON.stringify(params)));
  },
  //url解码
  decode: function (code) {
    return JSON.parse(window.decodeURIComponent(window.atob(code)));
  },
  isDomain:function(keyword){
    let regex = /^(?:https?:\/\/)?([\w.-]+(?:\.[\w.-]+)+)(?:[\w-._~:/?#[\]@!$&'()*+,;=]*)$/ig;
    return regex.test(keyword);
  },
  isEmail:function(keyword){
    let regex = /^([a-z0-9_\.-]+)@([\da-z\.-]+)\.([a-z\.]{2,6})$/i;
    return regex.test(keyword);
  },
  //api参数
  transform:function (params) {
    let apiParams = {};
    apiParams.dig = params.dig? params.dig :undefined;
    apiParams.current = params.page ?params.page : 1;
    apiParams.pageSize = params.pageSize ?params.pageSize:undefined;
    apiParams.keyword = params.keyword?params.keyword:undefined;
    apiParams.research = params.research?params.research:undefined;
    apiParams.type = params.searchType == 'website-email' ? 2 : params.searchType == 'com-all' ? 0 : 1;
    apiParams.ids  = params.ids ?params.ids:undefined;
    apiParams.force = params.force ?params.force:undefined;
    apiParams.modelName = params.modelName?params.modelName:undefined;
    apiParams.sender = params.sender?params.sender:undefined;
    apiParams.startTime = params.startTime?params.startTime:undefined;
    apiParams.endTime = params.endTime?params.endTime:undefined;
    return apiParams;
   }
};



// WEBPACK FOOTER //
// ./src/common/service/params-service.js